import { useTranslation } from 'react-i18next';
import BannerImage from '../../Assets/Image/Aps/jumbotron-catalog.png';
import CompactJumbotron from '../../Components/CompactJumbotron';

function CatalogJumbotron() {
    const { t } = useTranslation();

    return (
        <CompactJumbotron
            backgroundImage={BannerImage}
            title={t('aps.catalog_jb.title')}
            description={t('aps.catalog_jb.description')}
        />
    );
}

export default CatalogJumbotron;
